import React, { Fragment, useEffect, useState } from 'react';
import { Typography, Button, Form, message, Select, Modal, Spin } from 'antd';
import Axios from 'axios';
import { useSelector } from 'react-redux';
import { filterAccessibleSeasons } from '../../../utils/seasonFilter';
const { Option } = Select;
const { Title, Text } = Typography;

// 人事評価力診断(10010) 組織結果Excel「回答集計v0.3」ダウンロード。
// 集計・xlsx生成はサーバ(/api/dbModel100/excel10010)側で行い、本画面は
// 企業・サーベイ選択とダウンロードのトリガーのみを担う（サーバ完全生成方式）。
const Excel10010DownloadPage = () => {
  const [groups, setGroups] = useState([]);
  const [selGroupInfo, setSelGroupInfo] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState('');
  const [groupSurveySeasonInfo, setGroupSurveySeasonInfo] = useState([]);
  const [selSurveySeasonInfo, setSelSurveySeasonInfo] = useState([]);
  const [selSurveySeasonId, setSelSurveySeasonId] = useState('');
  const [submitSW, setSubmitSW] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [userInfo, setUserInfo] = useState({});

  const usr = useSelector((state) => state.user);

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      setUserInfo(usr.userData);

      const groupInfo = await Axios.get('/api/group/10010');

      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        const nonGroup = groupInfo.data.groups.filter(
          (item) => item.group_code !== 'RECRNT'
        );
        setGroups(nonGroup);
      } else {
        setGroups(groupInfo.data.groups);
      }

      if (usr.userData.role === 3) {
        let sgi = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );
        setSelGroupCode(usr.userData.groupCode);
        setSelGroupInfo(sgi);
        setGroupSurveySeasonInfo(
          filterAccessibleSeasons(sgi.survey_season, usr.userData, ['10010', '90101'])
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
  }, [usr]);

  const onChangeGroup = (value) => {
    let sgi = groups.find((item) => item.group_code === value);
    setSelGroupCode(value);
    setSelGroupInfo(sgi);
    setGroupSurveySeasonInfo(
      filterAccessibleSeasons(sgi.survey_season, usr.userData, ['10010', '90101'])
    );
    setSelSurveySeasonId('');
    setSelSurveySeasonInfo([]);
  };

  const onChangeSurveySeason = async (value) => {
    const sssi = groupSurveySeasonInfo.find((item) => item._id === value);
    setSelSurveySeasonId(value);
    setSelSurveySeasonInfo(sssi);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      message.loading({
        content: 'データ作成中...',
        key: 'makeexcel',
        duration: 60,
      });
      setIsModalVisible(true);
      setSubmitSW(false);

      const res = await Axios.post(
        '/api/dbModel100/excel10010',
        {
          group_code: selGroupCode,
          survey_season_id: selSurveySeasonId,
        },
        { responseType: 'blob' }
      );

      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Recurrent_10010_All_Result_List_${selGroupInfo.group_name}_${selSurveySeasonInfo.season_name}.xlsx`;
      a.click();
      a.remove();
      URL.revokeObjectURL(url);

      message.success({
        content: 'ダウンロード完了！',
        key: 'makeexcel',
        duration: 2,
      });
      setSubmitSW(true);
      setIsModalVisible(false);
    } catch (error) {
      console.log(error.message);
      setIsModalVisible(false);
      message.error({
        content: error.message,
        key: 'makeexcel',
        duration: 4,
      });
      setSubmitSW(true);
    }
  };

  return (
    <Fragment>
      <div style={{ maxWidth: '1100px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <Title level={2}>人事評価力診断結果ダウンロード(EXCEL)</Title>
        </div>
        <Form onSubmit={onSubmit}>
          <br />
          <Title style={{ color: 'var(--brand-primary)' }}>❶</Title>
          <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>
            企業を選択してください。（必須）
          </Text>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Select
              showSearch
              style={{ marginLeft: 0, marginRight: 10, width: 300 }}
              placeholder="企業選択"
              optionFilterProp="children"
              onChange={onChangeGroup}
              value={selGroupCode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              disabled={userInfo.role === 3}
            >
              {groups.map((element) => {
                return (
                  <Option value={element.group_code} key={element._id}>
                    {element.group_name}
                  </Option>
                );
              })}
            </Select>
          </div>
          <br />
          <div>
            <Title style={{ color: 'var(--brand-primary)' }}>❷</Title>
            <Text strong style={{ display: 'block', marginBottom: 'var(--space-4)' }}>
              サーベイを選択してください。（必須）
            </Text>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Select
                showSearch
                style={{ marginLeft: 0, marginRight: 5, width: 400 }}
                placeholder="サーベイ選択"
                optionFilterProp="children"
                onChange={onChangeSurveySeason}
                value={selSurveySeasonId}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {groupSurveySeasonInfo.map((element) => {
                  return (
                    <Option value={element._id} key={element._id}>
                      {element.season_name}
                    </Option>
                  );
                })}
              </Select>
            </div>
          </div>
          <Title style={{ color: 'var(--brand-primary)' }}>❸</Title>
          <Button
            type="default"
            className="ds-btn-secondary"
            size="large"
            onClick={onSubmit}
            disabled={!(submitSW && selSurveySeasonId)}
          >
            集計データダウンロード（Excel）
          </Button>
        </Form>
      </div>
      <Modal
        title="結果作成中..."
        open={isModalVisible}
        okButtonProps={{ disabled: true }}
        cancelButtonProps={{ disabled: true }}
        styles={{ body: { textAlign: 'center' } }}
      >
        <Spin size="large" />
      </Modal>
    </Fragment>
  );
};

export default Excel10010DownloadPage;
